import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const services = [{
  title: "Body Treatments",
  description: "Indulge in our restorative body treatments designed to release tension and nourish your skin with organic botanical oils and minerals.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/body_treatment_ritual.png",
  link: "/ServicesPage#bodytreatments"
}, {
  title: "Foot Treatments",
  description: "Ground yourself with our signature foot treatments with herbal soaks for total relaxation.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/foot_soak_therapy.png",
  link: "/ServicesPage#foottreatments"
}, {
  title: "Combo Services",
  description: "Our curated combinations offer a seamless journey of head-to-toe wellness and serenity.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/wellness_combo_package.png",
  link: "/ServicesPage#comboservices"
}];
export default function ServicesCardsResidential() {
  return <section data-section-id="253418" id="our-signature-rituals" className="bg-gradient-to-b from-background to-secondary/20 py-16 md:py-24 text-foreground">
      <div className="page-container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => <Card key={i} data-index={i} className="overflow-hidden hover:shadow-md transition-all duration-500 border-none bg-transparent flex flex-col h-full group">
              <AspectRatio ratio={4 / 5}>
                <img src={service.image} alt={service.title} className="object-cover w-full h-full rounded-3xl transition-transform duration-700 group-hover:scale-105" data-wvc-srcset={`${service.image}-wvc-srcset`} data-wvc-sizes={`${service.image}-wvc-sizes`} loading="lazy" />
              </AspectRatio>
              <CardHeader>
                <CardTitle className="font-default text-2xl text-primary tracking-tight">{service.title}</CardTitle>
              </CardHeader>
              <CardContent className="flex-grow">
                <p className="text-muted-foreground font-sans font-light leading-relaxed">{service.description}</p>
              </CardContent>
              <CardFooter>
                <Button asChild variant="outline" className="w-full group opacity-0 group-hover:opacity-100 transition-opacity duration-300 border-secondary text-primary hover:bg-secondary rounded-md">
                  <Link to={service.link}>
                    View Details
                    <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}